import { useState, useCallback } from 'react';

export const useModalState = <T = boolean>(
  initialValue: T,
  resetValue?: T,
): [T, (val: T) => void, () => void] => {
  const [opened, setOpened] = useState(initialValue);
  const close = useCallback(
    () => setOpened(resetValue === undefined ? initialValue : resetValue),
    [setOpened, initialValue, resetValue],
  );
  return [opened, setOpened, close];
};

export const useBoolModalState = (
  initialValue: boolean = false,
): [boolean, () => void, () => void, (opened: boolean) => void] => {
  const [opened, setOpened, close] = useModalState(initialValue, false);
  const open = useCallback(() => setOpened(true), [setOpened]);
  return [opened, open, close, setOpened];
};

export const useToggleModalState = (
  initialValue: boolean = false,
): [boolean, () => void, (opened: boolean) => void] => {
  const [opened, setOpened] = useModalState(initialValue, false);
  const toggle = useCallback(() => setOpened(!opened), [setOpened, opened]);
  return [opened, toggle, setOpened];
};
